import produce from 'immer'

import {
  SET_AUTO_VERSIONING_VERSION,
  SET_AUTO_VERSIONING_VERSION_SUCCESS,
  SET_AUTO_VERSIONING_VERSION_FAILURE,
  SET_AUTO_VERSIONING_BRANDS,
  SET_AUTO_VERSIONING_BRANDS_SUCCESS,
  SET_AUTO_VERSIONING_BRANDS_FAILURE,
  AUTO_VERSIONING_UNCONFIRM,
  AUTO_VERSIONING_UNCONFIRM_SUCCESS,
  AUTO_VERSIONING_UNCONFIRM_FAILURE,
  AUTO_VERSIONING_KICKOFF,
  AUTO_VERSIONING_KICKOFF_SUCCESS,
  AUTO_VERSIONING_KICKOFF_FAILURE,
  FETCH_AUTO_VERSIONING_PROGRESS,
  FETCH_AUTO_VERSIONING_PROGRESS_SUCCESS,
  FETCH_AUTO_VERSIONING_PROGRESS_FAILURE,
  AUTO_VERSIONING_RESET,
  AUTO_VERSIONING_RESET_SUCCESS,
  AUTO_VERSIONING_RESET_FAILURE,
  AUTO_VERSIONING_CANCEL,
  AUTO_VERSIONING_CANCEL_SUCCESS,
  AUTO_VERSIONING_CANCEL_FAILURE,
  AUTO_VERSIONING_ROLLBACK,
  AUTO_VERSIONING_ROLLBACK_SUCCESS,
  AUTO_VERSIONING_ROLLBACK_FAILURE,
} from '../actions/types'

export const initialBrandStatusState = {
  message: '',
  running: false,
  error: false,
  progress: 0,
  total: 0,
  finished: false,
  cancelled: false,
}

export const initialBrandState = {
  index: '',
  name: '',
  fullName: '',
  providers: [],
  enabled: false,
  alias: '',
  total: 0,
  status: null,
}

export const initialState = {
  currentStep: '',
  reindexInProgress: false,
  brandsAllIds: [],
  brandsById: {},
  newVersion: '',
  oldVersion: '',
  indexerVersions: '',

  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,

  setVersionPending: false,
  setVersionSuccess: false,
  setVersionError: false,

  setBrandsPending: false,
  setBrandsSuccess: false,
  setBrandsError: false,

  unconfirmPending: false,
  unconfirmSuccess: false,
  unconfirmError: false,

  resetPending: false,
  resetSuccess: false,
  resetError: false,

  rollbackPending: false,
  rollbackSuccess: false,
  rollbackError: false,

  cancelPending: false,
  cancelSuccess: false,
  cancelError: false,

  kickoffPending: false,
  kickoffSuccess: false,
  kickoffError: false,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_AUTO_VERSIONING_PROGRESS: {
      draft.fetching = true
      break
    }
    case FETCH_AUTO_VERSIONING_PROGRESS_SUCCESS: {
      const { currentStep, reindexInProgress, brands, newVersion, oldVersion, indexerVersions } = payload

      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      draft.currentStep = currentStep
      draft.reindexInProgress = reindexInProgress
      draft.newVersion = newVersion
      draft.oldVersion = oldVersion
      draft.indexerVersions = indexerVersions
      draft.brandsAllIds = brands.map((b) => b.name)
      draft.brandsById = brands.reduce((acc, brand) => {
        const id = brand.name
        acc[id] = {
          ...initialBrandState,
          ...brand,
          id,
          state: {
            ...initialBrandStatusState,
            ...brand.state,
          },
        }

        return acc
      }, {})

      break
    }
    case FETCH_AUTO_VERSIONING_PROGRESS_FAILURE: {
      const error = payload

      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }
    case SET_AUTO_VERSIONING_VERSION: {
      draft.setVersionPending = true
      break
    }
    case SET_AUTO_VERSIONING_VERSION_SUCCESS: {
      draft.setVersionPending = false
      draft.setVersionSuccess = true
      break
    }
    case SET_AUTO_VERSIONING_VERSION_FAILURE: {
      draft.setVersionPending = false
      draft.setVersionSuccess = false
      draft.setVersionError = payload
      break
    }
    case SET_AUTO_VERSIONING_BRANDS: {
      draft.setBrandsPending = true
      break
    }
    case SET_AUTO_VERSIONING_BRANDS_SUCCESS: {
      draft.setBrandsPending = false
      draft.setBrandsSuccess = true
      break
    }
    case SET_AUTO_VERSIONING_BRANDS_FAILURE: {
      draft.setBrandsPending = false
      draft.setBrandsSuccess = false
      draft.setBrandsError = payload
      break
    }
    case AUTO_VERSIONING_UNCONFIRM: {
      draft.unconfirmPending = true
      break
    }
    case AUTO_VERSIONING_UNCONFIRM_SUCCESS: {
      draft.unconfirmPending = false
      draft.unconfirmSuccess = true
      break
    }
    case AUTO_VERSIONING_UNCONFIRM_FAILURE: {
      draft.unconfirmPending = false
      draft.unconfirmSuccess = false
      draft.unconfirmError = payload
      break
    }
    case AUTO_VERSIONING_KICKOFF: {
      draft.kickoffPending = true
      break
    }
    case AUTO_VERSIONING_KICKOFF_SUCCESS: {
      draft.kickoffPending = false
      draft.kickoffSuccess = true
      break
    }
    case AUTO_VERSIONING_KICKOFF_FAILURE: {
      draft.kickoffPending = false
      draft.kickoffSuccess = false
      draft.kickoffError = payload
      break
    }
    case AUTO_VERSIONING_RESET: {
      draft.resetPending = true
      break
    }
    case AUTO_VERSIONING_RESET_SUCCESS: {
      draft.resetPending = false
      draft.resetSuccess = true
      break
    }
    case AUTO_VERSIONING_RESET_FAILURE: {
      draft.resetPending = false
      draft.resetSuccess = false
      draft.resetError = payload
      break
    }
    case AUTO_VERSIONING_CANCEL: {
      draft.cancelPending = true
      break
    }
    case AUTO_VERSIONING_CANCEL_SUCCESS: {
      draft.cancelPending = false
      draft.cancelSuccess = true
      break
    }
    case AUTO_VERSIONING_CANCEL_FAILURE: {
      draft.cancelPending = false
      draft.cancelSuccess = false
      draft.cancelError = payload
      break
    }
    case AUTO_VERSIONING_ROLLBACK: {
      draft.rollbackPending = true
      break
    }
    case AUTO_VERSIONING_ROLLBACK_SUCCESS: {
      draft.rollbackPending = false
      draft.rollbackSuccess = true
      break
    }
    case AUTO_VERSIONING_ROLLBACK_FAILURE: {
      draft.rollbackPending = false
      draft.rollbackSuccess = false
      draft.rollbackError = payload
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
